<!-- <AppButtonSocial href="https://t.me/uniquefabricru" social="telegram" /> -->

<template>
  <a :href="href"
    target="_blank"
    :class="classes"
    class="button-social">
    <app-svg :id="social"
      style="color: currentColor" />
  </a>
</template>

<script>
import { computed, reactive } from "vue";

export default {
  name: "ButtonSocial",
  props: {
    href: {
      type: [String, Array],
      default: null,
    },
    social: {
      type: [String, Array],
      default: null,
    },
    primary: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        _secondary: !props.primary,
      })),
    };
  },
};
</script>

<style lang="scss" scoped>
.button-social {
  overflow: hidden;
  cursor: pointer;
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  color: $color_dark-80;
  transition: color 0.25s ease-out, border-color 0.25s ease-out;

  & svg * {
    transition: all 0.25s ease-out;
    fill: currentColor;
    stroke: currentColor;
    color: currentColor;
  }

  @include hover {
    color: $color_orange-50;
  }

  @include phone {
    width: 32px;
    height: 32px;
  }
}
</style>
